export default function()
{
  // -----------------------------------------------------
  // PC　カード全体をリンクに
  // -----------------------------------------------------
  var pcLink = document.getElementsByClassName("js_pc_link")

  // 子孫に含まれるリンクを取得
  function pcLinkGo() {
    if (pcLink) {
      if (window.innerWidth > 750) {
        var link = this.querySelectorAll("a")[0].href
        window.location.href = link
      } else {
      }
    }
  }

  for (var i = 0; i < pcLink.length; i++) {
    pcLink[i].addEventListener("click", pcLinkGo)
  }
}
